import { useState } from "react";

const useUpdateGlobalPosition = () => {

  const updateGlobalPosition = (templates) => {
    if (!templates.metaData) return;
    
    templates.metaData.map( template => {
      if (template.styles.position != "relative") {
        
        template["left"] = {value:templates.left.value + (template.styles.left ? template.styles.left.value:0)};
        template["top"] = {value:templates.top.value + (template.styles.top ? template.styles.top.value:0)};
        updateGlobalPosition(template);
      }
    })
  
  };

  return updateGlobalPosition;
};

export default useUpdateGlobalPosition;
